import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../stores/localizationContext";
import "./SessionStudentReport.scss";

type SessionStudentReportProps = {
  language: string;
  classId: number;
  sessionId: number;
};

/**
 * Figma: Session Card — node 4607:3305 (View Students Reports)
 * https://www.figma.com/design/9mh46yI3LBoaQxvXsf1YXh/Nagwa-Tutors-Website?node-id=4607-3305
 */
export const SessionStudentReport: FC<SessionStudentReportProps> = ({
  language,
  sessionId,
}) => {
  const { t } = useLocalization();
  const navigate = useNavigate();

  const goToReports = () => {
    navigate(`/${language}/sessions/${sessionId}/report`);
  };

  return (
    <section
      className="session-student-report"
      aria-label={t("session_reports_section", "Student reports")}
    >
      <button
        type="button"
        className="session-student-report__card"
        onClick={goToReports}
      >
        <span className="session-student-report__text">
          <span className="session-student-report__label">
            {t("session_report_label")}
          </span>
        </span>
        <span className="session-student-report__icon" aria-hidden="true">
          <i className="f-icon chevron-right-icon" />
        </span>
      </button>
    </section>
  );
};
